import { useState, useEffect } from "react";
import apiDocumentos from "../api/Documentos/api-documentos";

export const useConvocatoriaImage = (portadaUrl?: string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [dataImg, setDataImg] = useState<any>();

  useEffect(() => {
    const getImageConvocatoria = async () => {
      if (portadaUrl) {
        try {
          const data = await apiDocumentos.consultarArchivo(portadaUrl);
          if (data?.data) {
            setLoading(false);
            const reader = new FileReader();
            reader.readAsDataURL(data.data);
            reader.onloadend = function () {
              const base64String = reader.result;
              setDataImg(base64String);
            };
          } else {
            setLoading(false);
          }
        } catch (error) {
          console.error("Error fetching convocatoria image:", error);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    getImageConvocatoria();
  }, [portadaUrl]);

  return { dataImg, loading };
};
